exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1lE0n5wit0nymWi_nL4y5x ._3r3XlXpFl5UMKm3JjXYS8s{position:absolute;top:0}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_1lE0n5wit0nymWi_nL4y5x",
	"view-ruler": "_3r3XlXpFl5UMKm3JjXYS8s"
};